(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.HabitatProductCardGallery) {
    window.HabitatProductCardGallery = true;

    const swipeThreshold = 35;
    const clickNavigationThreshold = 8;
    let activeSwipe = null;
    let pendingProductCardClick = null;

    function changeGalleryImage(gallery, direction, wrap = false) {
      const radios = Array.from(gallery.querySelectorAll(".product-card__gallery-radio"));
      const currentIndex = radios.findIndex((radio) => radio.checked);
      let nextIndex = currentIndex + direction;

      if (wrap) {
        nextIndex = (nextIndex + radios.length) % radios.length;
      }

      if (!radios[nextIndex]) {
        return false;
      }

      radios[nextIndex].checked = true;
      radios[nextIndex].dispatchEvent(new Event("change", { bubbles: true }));

      return true;
    }

    document.addEventListener("pointerdown", (event) => {
      const media = event.target.closest(".product-card__media--gallery");

      if (!media || !event.isPrimary || event.button > 0 || !window.matchMedia("(max-width: 699px)").matches) {
        return;
      }

      activeSwipe = {
        media,
        startX: event.clientX,
        startY: event.clientY
      };
    });

    document.addEventListener("pointerdown", (event) => {
      const link = event.target.closest("product-card a[href]");

      if (!link || !event.isPrimary || event.button > 0) {
        return;
      }

      pendingProductCardClick = {
        link,
        startX: event.clientX,
        startY: event.clientY
      };
    });

    document.addEventListener("pointerup", (event) => {
      if (!activeSwipe) {
        return;
      }

      const { media, startX, startY } = activeSwipe;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      activeSwipe = null;

      if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      const gallery = media.closest(".product-card__mobile-gallery");
      const direction = deltaX < 0 ? -1 : 1;

      if (changeGalleryImage(gallery, direction)) {
        media.dataset.galleryDragged = "true";
      }
    });

    document.addEventListener("pointercancel", () => {
      activeSwipe = null;
    });

    document.addEventListener("click", (event) => {
      const media = event.target.closest(".product-card__media--gallery");

      if (media?.dataset.galleryDragged) {
        event.preventDefault();
        delete media.dataset.galleryDragged;
      }
    }, true);

    document.addEventListener("click", (event) => {
      const link = event.target.closest("product-card a[href]");

      if (!link || !pendingProductCardClick || pendingProductCardClick.link !== link) {
        pendingProductCardClick = null;
        return;
      }

      const deltaX = Math.abs(event.clientX - pendingProductCardClick.startX);
      const deltaY = Math.abs(event.clientY - pendingProductCardClick.startY);
      pendingProductCardClick = null;

      if (!event.defaultPrevented || deltaX > clickNavigationThreshold || deltaY > clickNavigationThreshold) {
        return;
      }

      window.location.href = link.href;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
